import OwnerOfJurisdiction from './OwnerOfJurisdiction.vue';

export default OwnerOfJurisdiction;
